<div class="modal-body modal-no-title modal-congresses">
  <button type="button" class="close" aria-label="Close" (click)="activeModal.close(false)">
    <i class="fa fa-times" aria-hidden="true"></i>
  </button>
  <h2 class="text-center mt-2 mb-0">The world leading medical congress in aesthetic medicine is now also in Shanghai</h2>
  <img src="{{ environment.cdn_base_url }}/assets-front/img/china2025_academy_modal.jpg" style="margin-top: 1rem;margin-bottom: 1rem;">
  <a [href]="environment.base_url + '/' + locale + '/attend/imcas-china-2025'" class="transparent-button" target="_blank" (click)="activeModal.close(false)" style="background-color: #001148">{{'layout.More_info' | translate }}</a>
</div>
